
import React, { useState, useEffect } from 'react';
import { PRSStatusBadge } from "components-design-system"

const SiteStatusCellRenderer = ({ data }) => {
  const [display, setDisplay] = useState([]);

  useEffect(() => {
    if (data) {
      let items = []
      const tooltipType = "site"
      if (data.is_new) items.push(<PRSStatusBadge
        key="sd-new-badge"
        variant="new"
        tooltipType={tooltipType}
      />);
      if (data.recruitment_status_changed) items.push(<PRSStatusBadge
        key="sd-recruitment-status-badge"
        variant="recruitment"
        tooltipType={tooltipType}
      />);
      if (data.only_on_ctg) items.push(<PRSStatusBadge
        key="sd-no-source-badge"
        variant="no-source"
        tooltipType={tooltipType}
      />);
      else if (data.only_on_source) items.push(<PRSStatusBadge
        key="sd-no-ctg-badge"
        variant="no-ctg"
        tooltipType={tooltipType}
      />);
      setDisplay(items);
    }
  }, [data])

  return <div style={{ display: "flex", gap: 6 }}>
    {display}
  </div>
}

export default SiteStatusCellRenderer